import  React from "react";
import { useSelector } from "react-redux";
import { singletonHook } from 'react-singleton-hook';
import _ from 'lodash'

// let roles = {data:{}, actions:{}}
const useRolePermissionServices = ()=>{  
   
   let allRoles = [];

   allRoles = useSelector((state)=>{
       return state.auth.roles
   })

   const CensusRoles = {

   }
 
    const AttendanceRoles = {
        canMarkAttendance: _.includes(allRoles, "bedmanagement.recordattendance") || false
    }

    const SetupRoles = {

    }
   
    
    return {data:{CensusRoles, AttendanceRoles, SetupRoles}}
}

export default useRolePermissionServices// = singletonHook(roles, useRolePermissionServicesFn);;